import { easternInputToUtcIso } from "./timezone";

const TIME_ZONE = "America/New_York";

function easternDateKey(date) {
  const dtf = new Intl.DateTimeFormat("en-CA", {
    timeZone: TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  return dtf.format(new Date(date));
}

function diffParts(from, to) {
  let months =
    (to.getUTCFullYear() - from.getUTCFullYear()) * 12 +
    (to.getUTCMonth() - from.getUTCMonth());

  let anchor = new Date(
    Date.UTC(
      from.getUTCFullYear(),
      from.getUTCMonth() + months,
      from.getUTCDate(),
      from.getUTCHours(),
      from.getUTCMinutes(),
      from.getUTCSeconds()
    )
  );

  if (anchor > to) {
    months -= 1;
    anchor = new Date(
      Date.UTC(
        from.getUTCFullYear(),
        from.getUTCMonth() + months,
        from.getUTCDate(),
        from.getUTCHours(),
        from.getUTCMinutes(),
        from.getUTCSeconds()
      )
    );
  }

  const msLeft = to.getTime() - anchor.getTime();
  const days = Math.floor(msLeft / 86400000);
  const hours = Math.floor((msLeft % 86400000) / 3600000);
  const minutes = Math.floor((msLeft % 3600000) / 60000);

  return { months, days, hours, minutes };
}

// { status: "future" | "today" | "expired", text }
export function getCountdownDisplay(targetDate, now) {
  const target = new Date(targetDate);
  const current = new Date(now);

  const targetDay = easternDateKey(target);
  const todayDay = easternDateKey(current);

  if (targetDay < todayDay) {
    return { status: "expired", text: "" };
  }
  if (targetDay === todayDay) {
    return { status: "today", text: "Today!" };
  }

  const { months, days, hours, minutes } = diffParts(current, target);

  let text;
  if (months >= 1) {
    text = `${months}mo ${days}d`;
  } else if (days >= 1) {
    text = `${days}d ${hours}h ${minutes}m`;
  } else {
    text = `${hours}h ${minutes}m`;
  }

  return { status: "future", text };
}

// Next Dec 25, 12:00 AM Eastern — rolls to next year the day after Christmas.
export function getNextChristmas(now) {
  const current = new Date(now);
  const year = Number(easternDateKey(current).slice(0, 4));
  const thisYearChristmas = new Date(easternInputToUtcIso(`${year}-12-25T00:00`));

  if (easternDateKey(thisYearChristmas) < easternDateKey(current)) {
    return new Date(easternInputToUtcIso(`${year + 1}-12-25T00:00`));
  }

  return thisYearChristmas;
}

export function isWishlistLocked(wishlistDueDate, unlockedOverride, now) {
  if (!wishlistDueDate) return false;
  if (unlockedOverride) return false;
  return new Date(wishlistDueDate).getTime() <= new Date(now).getTime();
}
